// utils/faviconUtils.ts
import { clientLogger } from "modules/common/logger/client";

let originalFaviconHref: string | null = null;

export function initializeFavicon() {
  if (!originalFaviconHref) {
    const favicon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    originalFaviconHref = favicon?.href || "/favicon.ico";
  }
}

export function updateFaviconWithBadge(count: number) {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  const favicon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');

  if (!ctx || !favicon) return;

  canvas.width = 32;
  canvas.height = 32;

  // Ensure we have the original favicon
  initializeFavicon();

  const img = new Image();
  img.crossOrigin = "anonymous"; // Handle CORS if needed

  img.onload = () => {
    try {
      // Clear canvas
      ctx.clearRect(0, 0, 32, 32);

      // Draw the original favicon
      ctx.drawImage(img, 0, 0, 32, 32);

      if (count > 0) {
        // Draw red notification dot
        ctx.fillStyle = "#dc3545";
        ctx.beginPath();
        ctx.arc(24, 8, 6, 0, 2 * Math.PI);
        ctx.fill();

        // White border
        ctx.strokeStyle = "#ffffff";
        ctx.lineWidth = 2;
        ctx.stroke();

        // Add count if less than 100
        if (count < 100) {
          ctx.fillStyle = "#ffffff";
          ctx.font = "bold 8px system-ui";
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          const text = count > 99 ? "99+" : count.toString();
          ctx.fillText(text, 24, 8);
        }
      }

      // Update favicon
      favicon.href = canvas.toDataURL("image/png");
    } catch (error) {
      clientLogger.warn("favicon.update", "update favicon failed", { error: String(error) });
    }
  };

  img.onerror = () => {
    clientLogger.warn("favicon.load", "load favicon image failed");
  };

  img.src = originalFaviconHref || "/favicon.ico";
}

export function resetFavicon() {
  const favicon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (favicon && originalFaviconHref) {
    favicon.href = originalFaviconHref;
  }
}

export function updatePageTitle(count: number, baseTitle?: string) {
  const currentTitle = baseTitle || document.title.replace(/^\(\d+\) /, "");
  document.title = count > 0 ? `(${count}) ${currentTitle}` : currentTitle;
}
